export const TelevisionIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="83"
    height="54"
    viewBox="0 0 83 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M79.5361 0C80.9528 0.000273804 82.1015 1.14967 82.1016 2.56641V42.8838C82.1014 44.3004 80.9528 45.4489 79.5361 45.4492H41.7832V52.5352H55.7119C56.1163 52.5354 56.4439 52.8633 56.4443 53.2676C56.4443 53.6723 56.1165 54.0007 55.7119 54.001H26.3896C25.9849 54.0008 25.6562 53.6723 25.6562 53.2676C25.6567 52.8632 25.9852 52.5353 26.3896 52.5352H40.3174V45.4492H2.56641C1.14954 45.4492 0.000175198 44.3006 0 42.8838V2.56641C7.86816e-05 1.1495 1.14948 0 2.56641 0H79.5361ZM1.4668 42.8838C1.46697 43.4909 1.95924 43.9834 2.56641 43.9834H41.0322C41.0384 43.9832 41.0446 43.9824 41.0508 43.9824C41.0569 43.9824 41.0632 43.9832 41.0693 43.9834H79.5361C80.1431 43.9831 80.6356 43.4907 80.6357 42.8838V38.1191H1.4668V42.8838ZM74.0381 39.2188C75.05 39.2189 75.87 40.0389 75.8701 41.0508C75.8701 42.0628 75.0501 42.8836 74.0381 42.8838C73.026 42.8838 72.2051 42.0629 72.2051 41.0508C72.2052 40.0388 73.026 39.2188 74.0381 39.2188ZM2.56641 1.4668C1.95918 1.4668 1.46688 1.9592 1.4668 2.56641V36.6523H80.6357V2.56641C80.6357 1.95937 80.1431 1.46707 79.5361 1.4668H2.56641Z"
      fill="currentColor"
    />
  </svg>
);
